import script from "./UpdatePlanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePlanModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePlanModal.vue?vue&type=style&index=0&id=71db307e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71db307e"]])

export default __exports__